import { render, staticRenderFns } from "./PageField.vue?vue&type=template&id=c1ac06e6&"
import script from "./PageField.vue?vue&type=script&lang=js&"
export * from "./PageField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports